import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_medicalCertificate: {
         form: {
            certificateDetailsTextarea: {
               label: 'Cel wydania zaświadczenia',
               placeholder: 'Uzupełnij cel wydania zaświadczenia...',
            },
            leavingGuard: {
               successMessage: 'Wersja robocza zaświadczenia została zapisana.',
            },
            loader: {
               failedToFetch: 'Nie udało się pobrać danych do zaświadczenia lekarskiego.',
            },
         },
         panel: {
            actions: {
               approveAndPrint: {
                  label: 'Zatwierdź i drukuj',
               },
            },
            title: 'Zaświadczenie lekarskie',
         },
      },
   },
};

export const medicalCertificateTranslationKeys = createScopedTranslationKeys(
   translations.pl,
   'visit_medicalCertificate'
);
